import { render } from "./AGB_EN.vue?vue&type=template&id=b090194c"
import script from "./AGB_EN.vue?vue&type=script&lang=js"
export * from "./AGB_EN.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\stfg.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__